import type { SxProps, Theme } from '@mui/material/styles';

type TransferHistoryStyleMap = {
    headerRow: SxProps<Theme>
    headerCell: SxProps<Theme>
    clickableRow: SxProps<Theme>
};

export const transferHistoryStyles: TransferHistoryStyleMap = {
    headerRow: { bgcolor: 'grey.50' },
    headerCell: { fontWeight: 600 },
    clickableRow: { cursor: 'pointer' },
};
